import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "24", "height": "24", "viewBox": "0 0 24 12", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "id": "Union", "d": "M20.8986 3.42386C22.3289 4.11928 23.0053 5.72589 22.7691 7.29892C22.4961 9.11775 22.2275 10.9555 22.2275 10.9555L16.4539 10.4884L16.1425 6.66655C14.8427 6.30323 13.6573 6.12084 12.2415 6.12109C10.8183 6.12134 9.6461 6.3148 8.34025 6.68222L8.02748 10.4899L2.25376 10.9591L1.70207 7.27909C1.46817 5.71887 2.14471 4.13002 3.56278 3.43791C6.18415 2.15851 9.12948 1.44031 12.2423 1.43975C15.3462 1.4392 18.2834 2.15226 20.8986 3.42386Z", "stroke": "currentColor", "stroke-width": "1.7" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const StepDownIcon = __component__.exports;
export {
  StepDownIcon as default
};
